// i was about to import tailwind css but for sake of skills how case i handwritten my css....

import React from 'react'

import { css, cx } from '@emotion/css'; //task requirement :(


// inconsistent with my inline, css module usage... but just want to demonstrate different technique of using emotion css
const buttonBase = css`
    border-radius: .25rem;
    cursor: pointer;
    display: inline-block;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.25;
    padding: .75em 1.5em;
    text-decoration: none;
    transition: all .2s ease-out;

    box-sizing: border-box;
    border: 0 solid #e2e8f0;

    outline:none;

    

    box-shadow:0px 4px 20px -8px #2a2e6c73;
    &:hover{
        box-shadow:0px 3px 15px #2a2e6c73;
    }
  
`

const buttonPrimary = css`
background-image: linear-gradient(
90deg
,#207cc9 0,#5ba7e5 51%,#207cc9);
background-size: 200% auto;
color: #fff;

box-shadow:0px 4px 20px -8px #2a2e6c73;
`


const buttonDanger = css`
background-image: linear-gradient(
90deg
,#f12424 0,#f78585 51%,#f12424);
background-size: 200% auto;
color: #fff;

box-shadow:0px 4px 20px -8px #2a2e6c73;
`

const buttonGreenAds = css`

flex-shrink: 0;
max-width: 119px;
padding: 10px 5px;


text-align:center;
font-size:10px;

min-width: 135px;


// display: flex;
// justify-content: center;
// align-items: center;


background-image: linear-gradient(
90deg
,#03ac0e 0,#6cde45 51%,#03ac0e);
background-size: 200% auto;
color: #fff;

box-shadow:0px 4px 20px -8px #2a2e6c73;

@media(min-width: 560px){
    max-width: 1000px;
}
`


const buttonOrangeAds = css`

flex-shrink: 0;
max-width: 119px;
padding: 10px 5px;


text-align:center;
font-size:10px;

min-width: 135px;


// display: flex;
// justify-content: center;
// align-items: center;


background-image: linear-gradient(to right, #f12711, #f5af19); 
background-size: 200% auto;
color: #fff;

box-shadow:0px 4px 20px -8px #f12711;

@media(min-width: 560px){
    max-width: 1000px;
}
`




// created root button component and create its inheritance, reusable ;) *wink*
// TAKE PARENTS CLASS TO BE MERGED , nice...
export function Button(props) {
    return (
        <button className={cx(props.className, buttonBase)} onClick={props.onClick} data-testid={props['data-testid']}>
            { props.children}
        </button>
    )
}

export function ButtonPrimary(props) {
    return (
        <button className={cx(props.className, buttonBase, buttonPrimary)} onClick={props.onClick} data-testid={props['data-testid']}>
            { props.children}
        </button>
    )
}


export function ButtonDanger(props) {
    return (
        <button className={cx(props.className, buttonBase, buttonDanger)} onClick={props.onClick} data-testid={props['data-testid']}>
            { props.children}
        </button>
    )
}


export function ButtonSecondary(props) {
    return (
        <button className={cx(props.className, buttonBase)} onClick={props.onClick} data-testid={props['data-testid']}>
            { props.children}
        </button>
    )
}

export function ButtonLinkGreen(props) {
    return (
        <a type="button" target="_blank" rel="noreferrer" className={cx(props.className, buttonBase, buttonGreenAds)} onClick={props.onClick} href={props.href}>
            { props.children}
        </a>
    )
}
export function ButtonOrangeAds(props) {
    return (
        <a type="button" target="_blank" rel="noreferrer" className={cx(props.className, buttonBase, buttonOrangeAds)} onClick={props.onClick} href={props.href}>
            { props.children}
        </a>
    )
}
